import { createContext, ReactNode, useEffect, useState } from "react"
import { get } from "../services/api/api"
import Community from "../models/community"
import { logger } from "../services/utils/utils"

interface CommunityContextInterface {
  communityLoading: boolean
  communityError: boolean
  community: Community | null
  getCommunity: (withLoading?: boolean) => Promise<void>
}

const CommunityContext = createContext<CommunityContextInterface>({
  communityLoading: true,
  communityError: false,
  community: null,
  getCommunity: async () => {},
})

const CommunityController = ({ children }: { children: ReactNode }) => {
  // loadings
  const [communityLoading, setCommunityLoading] = useState<boolean>(true)

  // errors
  const [communityError, setCommunityError] = useState<boolean>(false)

  // states
  const [community, setCommunity] = useState<Community | null>(null) // current community

  // get current community
  const getCommunity = async (withLoading = true) => {
    if (withLoading) {
      setCommunityLoading(true)
    }
    setCommunityError(false)

    try {
      const result = await get("/web/community/get")

      logger("community", result.data)
      setCommunity(result.data)

      setCommunityLoading(false)
    } catch (e) {
      logger("community error", e)
      setCommunityLoading(false)
      setCommunityError(true)
    }
  }

  // initial fetch
  useEffect(() => {
    getCommunity()
  }, [])

  return (
    <CommunityContext.Provider
      value={{
        communityLoading,
        communityError,
        community,
        getCommunity,
      }}
    >
      {children}
    </CommunityContext.Provider>
  )
}
export { CommunityController, CommunityContext }
